import { RecipeRelatedProductQueryDocument, RelateWithProductResponse } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { IRecipeRelatedProductRepository } from '@modules/recipes/application/ports/relatedProduct.repository.port';
import { left, right } from '@shared/utils/either.utils';
import { RecipeRelatedProductEntityMapper } from '../../outbound/ports/relatedProduct.mapper';
export class RecipeRelatedProductRepositoryImpl implements IRecipeRelatedProductRepository {
  async getRelatedProduct(slug: string): IRecipeRelatedProductRepository.getRelatedProductOutput {
    try {
      const {
        data
      } = await gqlQuery({
        query: RecipeRelatedProductQueryDocument,
        variables: {
          data: {
            slug
          }
        }
      });
      const output: RelateWithProductResponse[] = data.getRecipe.recipeProduct;
      const relatedProductList = output ? output.map(relatedProduct => RecipeRelatedProductEntityMapper.toDomain(relatedProduct)) : [];
      return right(relatedProductList);
    } catch (error: any) {
      console.error('error RecipeRelatedProductRepositoryImpl', error);
      return left(error);
    }
  }
}